import { render } from "./InstanceDetailOptionsR.vue?vue&type=template&id=4bff9600&scoped=true&ts=true"
import script from "./InstanceDetailOptionsR.vue?vue&type=script&lang=ts"
export * from "./InstanceDetailOptionsR.vue?vue&type=script&lang=ts"

import "./InstanceDetailOptionsR.vue?vue&type=style&index=0&id=4bff9600&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bff9600"]])

export default __exports__